import validator from '../../config/validator';

export const on_username = (val) => {
	const validateResultMessage = validator("post_users", 'username', val);
	return validateResultMessage;
};

export const on_permission = (val) => {
	const validateResultMessage = validator("post_users", 'permission', val);
	return validateResultMessage;
};
